/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography, Divider, Button, CircularProgress } from '@material-ui/core'
import { Add } from '@material-ui/icons'

import SearchScreen from './components/SearchScreen'

import Actions from '../../../../fluid/Actions/ActionFactory'
import { v4 as uuidv4 } from 'uuid';
const clone = require("rfdc")();


let search_temp = {
    type: "screen",
    name: null,
    route: null,
    config: "/src/configs/screens/screens/queue-config.js",
    roles: ["ROLE_L1", "ROLE_ADMIN"],
    show_in_sidebar : true,
    default_params : {
        search_type : 'freetext',
        search_fields : [],
        icList : [],
        icObjectList : [],
        icWVFieldMap : [],
        showAppbar : true,
        showSearchbar : true,
        copyToParent : false,
        filters : [],
        external_sources : [],
        cta_config : [],
        screen_cta_config: null
    },
    component : "search"
}

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class SearchScreens extends Component {
    state = {
        loading_ics : true,
        all_ic_objects : null,
        loading : false,
        search_screens : [],
        editing_id : null
    }

    componentDidMount () {
        this.setState({...this.state, loading_ics : true}, () => {
            Actions("http_request", {
                url : "/sainapse/information_channel",
                method : 'get'
            }).then(res => {
                let ic_objects = res.data.result.filter(ic_obj => {return ic_obj.operations.includes("Recommend") || ic_obj.operations.includes("Classify")})
                this.setState({...this.state, all_ic_objects : ic_objects}, () => this.getSearchScreens())
            }).catch(err => {

            })
        })
    }

    getSearchScreens = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
        let op_section = routes.drawer.find(section => section.id === 'operations')
        let search_section = op_section.screens.find(section => section.id === 'search')
        let search_screens = search_section.screens.filter(screen => screen.component === 'search').filter(screen => screen.default_params !== null)
        this.setState({...this.state, search_screens: search_screens, loading_ics : false}, () => console.log("Search Screens : ", this.state.search_screens))
    }

    updateSearchScreens = (search_screens) => {
        console.log("Updating Search Screens with : ", search_screens)
        Actions('http_request', {
            url : "/sainapse/configuration/ui_routes",
            method : "get",
            data : {}
          }).then(res => {
            //let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let routes = res.data.result.config
            let op_section = routes.drawer.find(section => section.id === 'operations')
            let search_section = op_section.screens.find(section => section.id === 'search')
            let default_screens = search_section.screens.filter(screen => screen.default_params === null)
            search_section.screens = [...default_screens, ...search_screens]
            console.log("Adding Search Screens to Routes : ", search_section)
            console.log("Updating Routes : ", routes)
            
            Actions('http_request', {
                url : "/sainapse/configuration/ui_routes",
                method : "put",
                data : {
                    config : routes
                }
            }).then(res => {
                let routes = res.data.result.config
                let op_section = routes.drawer.find(section => section.id === 'operations')
                let search_section = op_section.screens.find(section => section.id === 'search')
                let search_screens = search_section.screens.filter(screen => screen.component === 'search').filter(screen => screen.default_params !== null)
                this.setState({...this.state, search_screens: search_screens, editing_id : null}, () => sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config)))
            })
          })
    }

    updateSearch = (search_config) => {
        Actions('http_request', {
            url : "/sainapse/configuration/ui_routes",
            method : "get",
            data : {}
          }).then(res => {
            //let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let routes = res.data.result.config
            let op_section = routes.drawer.find(section => section.id === 'operations')
            let search_section = op_section.screens.find(section => section.id === 'search')
            let search_screens = search_section.screens.filter(screen => screen.component === 'search').filter(screen => screen.default_params !== null)

            let search_index = search_screens.findIndex(search => search.id === search_config.id)
            if (search_index !== -1) {
                console.log("Updating Search Screen: ", search_config)
                search_screens.splice(search_index, 1, search_config)
            } else {
                console.log("Adding Search Screen: ", search_config)
                search_screens.push(search_config)
            }
            this.updateSearchScreens(search_screens)
          })    
    }

    deleteSearch = (config) => {
        let new_state = clone(this.state)
        let search_index = new_state.search_screens.findIndex(screen => screen.id === config.id)
        new_state.search_screens.splice(search_index, 1)
        this.updateSearchScreens(new_state.search_screens)
    }

    editSearch = (config) => {
        this.setState({...this.state, editing_id : config.id})
    }

    renderSearchScreens = () => {
        if (this.state.loading) {
            return (
                <div style = {{width : '100%', marginTop : '30px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                    <CircularProgress variant = 'indeterminate'/>
                </div>
            )
        } else {
            let search_screens = this.state.search_screens.map(search_screen => {
                return (
                    <SearchScreen
                        ic_list = {this.state.all_ic_objects}
                        config = {search_screen}
                        update = {(config) => this.updateSearch(config)}
                        delete = {(config) => this.deleteSearch(config)}
                        enable_edit = {(config) => this.editSearch(config)}
                        editing_id = {this.state.editing_id}
                    />
                )
            })

            return search_screens
        }
    }

    addScreen = () => {
        let new_case = clone(search_temp)
        new_case.id = uuidv4()
        let new_state = clone(this.state)
        new_state.search_screens.push(new_case)
        new_state.editing_id = new_case.id
        this.setState({...new_state})
    }

    renderAddScreen = () => {
        return (
            <Button
                style = {{marginTop : '10px'}}
                variant = 'contained'
                size = 'small'
                color = 'primary'
                startIcon = {<Add/>}
                onClick = {this.addScreen}
            >
                Add Screen
            </Button>
        )
    }

    renderContent = () => {
        if (this.state.loading_ics) {
            return (
                <div style = {{width : '100%', padding : '50px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress variant = 'indeterminate' color = 'primary'/>
                </div>
            )
        } else {
            return (
                <Fragment>
                    {this.renderSearchScreens()}
                    {this.renderAddScreen()}
                </Fragment>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', maxHeight : '100%', overflow : 'auto', padding : '10px'}}>
                    <Typography variant = 'subtitle2'>Cognitive Search Screens</Typography>
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    {this.renderContent()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(SearchScreens);